import { render } from "./Breaks.vue?vue&type=template&id=952b2474"
import script from "./Breaks.vue?vue&type=script&lang=js"
export * from "./Breaks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__